import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchCurrentCompany } from "./api"

export function useFetchCurrentCompany() {
  const getContext = useApiContext()
  return useQuery({
    queryKey: ["company", "current"],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchCurrentCompany(context)
    },
    staleTime: 1000 * 60 * 10,
    refetchInterval: (query) => {
      const company = query.state.data
      if (!company) return false
      // Poll every 3 seconds while AI is generating the profile
      if (company.ai_generating_profile_at) return 3000
      return false
    },
  })
}
